export const DATE_FROM_TEXTS = {
  fieldLabel: 'Дата вылета',
  valuePrefix: 'с ',
  rangeJoin: ' по ',
  flexSign: '±',
  mobileRangeJoin: ' – ',
} as const;
